const IMAGE_EXTENSIONS = new Set(['jpg', 'jpeg', 'png', 'gif', 'webp']);

export function getQuizQuestionFileExtension(urlOrExtension) {
    if (!urlOrExtension || typeof urlOrExtension !== 'string') return '';
    const value = urlOrExtension.trim().toLowerCase();
    if (!value.includes('/') && !value.includes('.')) {
        return value.replace(/^\./, '');
    }
    const clean = value.split('?')[0].split('#')[0];
    const parts = clean.split('.');
    return parts.length > 1 ? parts.pop() : '';
}

export function isQuizQuestionImageFile(urlOrExtension) {
    return IMAGE_EXTENSIONS.has(getQuizQuestionFileExtension(urlOrExtension));
}

export function getQuizQuestionDownloadLabel(urlOrExtension) {
    return isQuizQuestionImageFile(urlOrExtension) ? 'دانلود تصویر' : 'دانلود PDF';
}
